import styled from 'styled-components';
import React, { ReactElement, MouseEvent } from 'react';
import { StyledDismissIcon } from '@westwing/ui-kit/Icons/StyledIcons';

const StyledHeader = styled.div`
    position: relative;
    background: ${({ theme }) => theme.colors.white};
    height: 60px;
    line-height: 60px;
    padding: 0 10px;
`;

const StyledTitle = styled.p`
    position: absolute;
    display: block;
    left: 0;
    top: 20px;
    padding: 0;
    outline: 0;
    border: none;
    background: 0 0;
`;

const StyledDismissButton = styled(StyledDismissIcon)`
    position: relative;
    left: 0px;
    top: 20px;
`;

export interface HeaderProps {
    handleDismissClick: (event: MouseEvent<HTMLButtonElement>) => void;
    identifier: string;
    title?: string;
}

const Header = ({ title, identifier, handleDismissClick }: HeaderProps): ReactElement => (
    <StyledHeader data-testid="overlay-header">
        <StyledDismissButton onClick={handleDismissClick} data-identifier={identifier} />
        <StyledTitle>{title}</StyledTitle>
    </StyledHeader>
);

export default Header;
